import React from "react";
import { useNavigate } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";

function BackButton({ onClick, to, className = "" }) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`flex-shrink-0 w-9 h-9 md:w-11 md:h-11 flex items-center justify-center bg-white hover:bg-orange-50 border-2 border-orange-200 hover:border-orange-400 rounded-xl shadow-sm hover:shadow-md transition-all duration-200 text-orange-600 group ${className}`}
    >
      <IoArrowBack className="text-lg md:text-xl group-hover:-translate-x-0.5 transition-transform duration-200" />
    </button>
  );
}

export default BackButton;
